<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div
    data-slot="stat-header"
    :class="cn('mb-1 flex min-h-4 max-w-full items-center gap-1 text-xs/4 text-secondary', props.class)"
  >
    <slot />
  </div>
</template>
